import { createSelector } from 'reselect';
import { RootState } from '../../../rootReducer';
import { localizationPropertyNames, prepareNumberValue } from '../Annotations/gridSelector';
import { shouldShowFinding } from '../Canvas/Helpers';

const getGrid = (state: RootState) => state.annotation.annotationsGrid;
const getStandard = (state: RootState) => state.annotation.annotationStandardDetails;
const getShowAllFindings = (state: RootState) => state.canvas.toggleAllUserFindingsVisibility;
const getShowMLFindings = (state: RootState) => state.canvas.toggleMLFindingsVisibility;
const getSelectedName = (state: RootState) => state.annotation.selectedName;

export const prepareCanvasGridDataSelector = createSelector(
  [getGrid, getStandard, getShowAllFindings, getShowMLFindings, getSelectedName],
  (gridData, standard, showAll, showML, selectedName) => {
    if (!gridData || !standard) {
      return [];
    }

    let dataSource = gridData
      .filter(x => shouldShowFinding(showAll, showML, x.isReviewed || x.isQaReviewed))
      .map(x => {
        let newData: any = { ...x };
        x.properties.forEach(prop => {
          newData[prop.name] = localizationPropertyNames.includes(prop.name) ? prepareNumberValue(prop.value, prop.name) : prop.value;
        });
        return newData;
      });

    return dataSource;
  }
);
